import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { MAIN_CONTENT_HEIGHT } from '@/catalog-apps/components/config'
import { PageHeader } from '@/components/ui/PageHeader'
import { DmpChatRuntimeProvider } from '@/features/dmp-chat/components/DmpChatRuntimeProvider'
import { DmpChatAgentProvider } from '@/features/dmp-chat/components/DmpChatAgentContext'
import { DmpChatHeaderActions } from '@/features/dmp-chat/components/DmpChatHeaderActions'
import { DmpChatHistory } from '@/features/dmp-chat/components/DmpChatHistory'
import { DmpChatThread } from '@/features/dmp-chat/components/DmpChatThread'
import { useSessionStorage } from '@/hooks'
import { isSuperUser } from '@/util'
import { Navigate } from 'react-router'
import { ProjectsBreadcrumbs } from '../ProjectsBreadcrumbs'
import { useCurrentProject } from '../useCurrentProject'
import { getProjectOrganisationId } from '../useUserLinkedProjects'

export function DmpChatPage() {
  const [roles] = useSessionStorage('roles', 0)

  if (!isSuperUser(roles)) {
    return <Navigate to="/" replace />
  }

  return (
    <QueryErrorBoundary errorMessage="Failed to load DMP Chat">
      <DmpChatPageContent />
    </QueryErrorBoundary>
  )
}

function DmpChatPageContent() {
  const project = useCurrentProject()
  const organisationId = getProjectOrganisationId(project)

  return (
    <DmpChatAgentProvider key={project.projectId} projectId={project.projectId}>
      <DmpChatRuntimeProvider key={project.projectId} organisationId={organisationId} projectId={project.projectId}>
        <div className="flex min-h-0 w-full min-w-0 flex-col overflow-hidden" style={{ height: MAIN_CONTENT_HEIGHT }}>
          <PageHeader className="shrink-0 pr-3" title={<ProjectsBreadcrumbs title="DMP Chat" />}>
            <DmpChatHeaderActions />
          </PageHeader>
          <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-5 pb-5 pr-3 pt-5 md:flex-row">
            <DmpChatHistory organisationId={organisationId} projectId={project.projectId} />
            <DmpChatThread projectName={project.name} />
          </div>
        </div>
      </DmpChatRuntimeProvider>
    </DmpChatAgentProvider>
  )
}
